module.exports = __webpack_public_path__ + "img/NivelLiquido.be6a9389.svg";